<template>
    <div v-if="actionType == 'move'" class="category">
        <div class="categoryName categoryMoveTo">
            <input @change="categoryChange(category.id)" type="radio" name="mergeto" :id="`category${category.id}`" :value="category.id"> 
            <label :for="`category${category.id}`">
                {{category.name}}
            </label>            
        </div>        
    </div>
    <div v-else class="category">
        <div class="categoryName" @click="hide_down_block = !hide_down_block">
            {{category.name}}
            <span v-show="hide_down_block">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.79879 7.03284L6.00589 3.29152L2.14908 6.96693L0.983957 5.81515L6.02563 1.00011L10.9836 5.90131L9.79879 7.03284Z" fill="white"/>
                </svg>
            </span>
            <span v-show="!hide_down_block">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.175 1.11649e-07L5 3.7085L8.825 1.48654e-08L10 1.1417L5 6L1.30974e-08 1.1417L1.175 1.11649e-07Z" fill="white"/>
                </svg>
            </span>
        </div>
        <div 
            v-show="hide_down_block"             
            :class="{'personsArea': (category.persons.length > 4)}"
        >
            <div v-for="(person, idxp) in category.persons" :key="idxp" class="personMergeTo">            
                <input @change="pesonChange(person.id)" type="radio" name="mergeto" :id="`person${person.id}`" :value="person.id"> 
                <label :for="`person${person.id}`">
                    {{person.first_name}} {{person.last_name}}
                </label>
            </div>            
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';

export default {
    props: [
        'category',
        'videos',
        'actionType'
    ],
    data(){
        return{
            hide_down_block: false
        }
    },
    methods: {
        categoryChange(id){            
            bus.$emit('changeCategoryMoveTo' , {
                left_person_id: id,
                new_category_id: this.category.id
            });
        },        
        pesonChange(id){            
            bus.$emit('changePersonMergeTo' , {
                left_person_id: id,
                new_category_id: this.category.id
            });
        },
        categoryChange(id){
            console.log('new_category_id', id);
            bus.$emit('changeCategoryMoveTo' , {
                new_category_id: id
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .category{
        margin: 5px 0;
    }
    .personsArea {
        height: 200px;
        overflow-y: scroll;
    }
    .categoryName{
        cursor: pointer;
    }    
    .personMergeTo, .categoryMoveTo {
        margin: 10px;
        input, label {
            cursor: pointer;
        }
    }
</style>
